// extracted by mini-css-extract-plugin
module.exports = {"timeLabel":"_93444fe79c--timeLabel--64z5q","relative":"_93444fe79c--relative--3CL2X","absolute":"_93444fe79c--absolute--1BX9t"};